import { BaseEntity } from "yt-ng-framework";

export class FirmaZrcView extends BaseEntity{
    constructor(){
        super();
    }

    Zrc:string = null;
    Glavni:boolean = null;
    Devizni:boolean = null;
    Banka:string = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.Zrc=input.Zrc;
        this.Glavni=input.Glavni;
        this.Devizni=input.Devizni;
        this.Banka=input.Banka;
        return this;
    }

    Serialize(input:FirmaZrcView){
        return input;
    }
}